// extracted by mini-css-extract-plugin
module.exports = {"button":"theme_button_18JSF","message":"theme_message_5AOIZ","title":"theme_title_3Qs8A"};